import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, tuple_type, record_type, option_type, string_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC__toDateTimeOffset, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { stackClasses, DateTimeOffsetExtensions_toDateHHmmss, logei } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { getWrappedMaterialIcon } from "../../ViewUtils.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import "../../../src/Containers/FileImport/Common.scss";


export class FileImport extends Record {
    constructor(BulkImportId, BulkImportName, CreatedAtUtc, ParsedAtUtc, ApprovedByUserId, ApprovedByName, ApprovedAtUtc, RejectedByUserId, RejectedByName, RejectedAtUtc, CompletedAtUtc, ErrorAtUtc, Error$, State, StatisticsJson) {
        super();
        this.BulkImportId = (BulkImportId | 0);
        this.BulkImportName = BulkImportName;
        this.CreatedAtUtc = CreatedAtUtc;
        this.ParsedAtUtc = ParsedAtUtc;
        this.ApprovedByUserId = ApprovedByUserId;
        this.ApprovedByName = ApprovedByName;
        this.ApprovedAtUtc = ApprovedAtUtc;
        this.RejectedByUserId = RejectedByUserId;
        this.RejectedByName = RejectedByName;
        this.RejectedAtUtc = RejectedAtUtc;
        this.CompletedAtUtc = CompletedAtUtc;
        this.ErrorAtUtc = ErrorAtUtc;
        this.Error = Error$;
        this.State = State;
        this.StatisticsJson = StatisticsJson;
    }
}

export function FileImport$reflection() {
    return record_type("Containers.FileImport.Common.FileImport", [], FileImport, () => [["BulkImportId", int32_type], ["BulkImportName", string_type], ["CreatedAtUtc", UTC$reflection()], ["ParsedAtUtc", option_type(UTC$reflection())], ["ApprovedByUserId", option_type(int32_type)], ["ApprovedByName", option_type(string_type)], ["ApprovedAtUtc", option_type(UTC$reflection())], ["RejectedByUserId", option_type(int32_type)], ["RejectedByName", option_type(string_type)], ["RejectedAtUtc", option_type(UTC$reflection())], ["CompletedAtUtc", option_type(UTC$reflection())], ["ErrorAtUtc", option_type(UTC$reflection())], ["Error", option_type(string_type)], ["State", string_type], ["StatisticsJson", option_type(string_type)]]);
}

export class StatisticsItem extends Record {
    constructor(name, value) {
        super();
        this.name = name;
        this.value = (value | 0);
    }
}

export function StatisticsItem$reflection() {
    return record_type("Containers.FileImport.Common.StatisticsItem", [], StatisticsItem, () => [["name", string_type], ["value", int32_type]]);
}

export class FileImportState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Error", "Rejected", "Completed", "PendingRejection", "Parsing", "PendingApproval", "Importing", "StateError", "UnknownState"];
    }
}

export function FileImportState$reflection() {
    return union_type("Containers.FileImport.Common.FileImportState", [], FileImportState, () => [[["Item", tuple_type(UTC$reflection(), string_type)]], [["Item", tuple_type(UTC$reflection(), string_type)]], [["Item", tuple_type(UTC$reflection(), string_type)]], [["Item", tuple_type(UTC$reflection(), string_type)]], [], [], [["Item", tuple_type(UTC$reflection(), string_type)]], [], []]);
}

export function FileImportState_OfFileImport_Z76481C2E(fi) {
    const matchValue = fi.State;
    switch (matchValue) {
        case "ERROR": {
            const matchValue_1 = [fi.ErrorAtUtc, fi.Error];
            let pattern_matching_result, errorAtUtc, errorMsg;
            if (matchValue_1[0] != null) {
                if (matchValue_1[1] != null) {
                    pattern_matching_result = 0;
                    errorAtUtc = matchValue_1[0];
                    errorMsg = matchValue_1[1];
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    return new FileImportState(0, [errorAtUtc, errorMsg]);
                }
                case 1: {
                    logei(toText(printf("[FileImportState - OfFileImport] ERROR state without ErrorAtUtc:%A or Error: %A"))(fi.ErrorAtUtc)(fi.Error));
                    return new FileImportState(7);
                }
            }
        }
        case "REJECTED": {
            const matchValue_2 = [fi.RejectedAtUtc, fi.RejectedByName];
            if (matchValue_2[0] != null) {
                if (matchValue_2[1] == null) {
                    const rejectedAtUtc_1 = matchValue_2[0];
                    return new FileImportState(1, [rejectedAtUtc_1, defaultArg(map(int32ToString, fi.RejectedByUserId), "?")]);
                }
                else {
                    const rejectedAtUtc = matchValue_2[0];
                    const rejectedByName = matchValue_2[1];
                    return new FileImportState(1, [rejectedAtUtc, rejectedByName]);
                }
            }
            else {
                logei(toText(printf("[FileImportState - OfFileImport] REJECTED state without RejectedAtUtc:%A or RejectedByName: %A"))(fi.RejectedAtUtc)(fi.RejectedByName));
                return new FileImportState(7);
            }
        }
        case "COMPLETED": {
            const matchValue_3 = [fi.ApprovedAtUtc, fi.ApprovedByName];
            if (matchValue_3[0] != null) {
                if (matchValue_3[1] == null) {
                    const approvedAtUtc_1 = matchValue_3[0];
                    return new FileImportState(2, [approvedAtUtc_1, defaultArg(map(int32ToString, fi.ApprovedByUserId), "?")]);
                }
                else {
                    const approvedAtUtc = matchValue_3[0];
                    const approvedByName = matchValue_3[1];
                    return new FileImportState(2, [approvedAtUtc, approvedByName]);
                }
            }
            else {
                logei(toText(printf("[FileImportState - OfFileImport] COMPLETED state without ApprovedAtUtc:%A or ApprovedByName: %A"))(fi.ApprovedAtUtc)(fi.ApprovedByName));
                return new FileImportState(7);
            }
        }
        case "PENDING_REJECTION": {
            const matchValue_4 = [fi.RejectedAtUtc, fi.RejectedByName];
            if (matchValue_4[0] != null) {
                if (matchValue_4[1] == null) {
                    const rejectedAtUtc_3 = matchValue_4[0];
                    return new FileImportState(3, [rejectedAtUtc_3, defaultArg(map(int32ToString, fi.RejectedByUserId), "?")]);
                }
                else {
                    const rejectedAtUtc_2 = matchValue_4[0];
                    const rejectedByName_1 = matchValue_4[1];
                    return new FileImportState(3, [rejectedAtUtc_2, rejectedByName_1]);
                }
            }
            else {
                logei(toText(printf("[FileImportState - OfFileImport] PENDING_REJECTION state without RejectedAtUtc:%A or RejectedByName: %A"))(fi.RejectedAtUtc)(fi.RejectedByName));
                return new FileImportState(7);
            }
        }
        case "PARSING": {
            return new FileImportState(4);
        }
        case "PENDING_APPROVAL": {
            return new FileImportState(5);
        }
        case "IMPORTING": {
            const matchValue_5 = [fi.ApprovedAtUtc, fi.ApprovedByName];
            if (matchValue_5[0] != null) {
                if (matchValue_5[1] == null) {
                    const approvedAtUtc_3 = matchValue_5[0];
                    return new FileImportState(6, [approvedAtUtc_3, defaultArg(map(int32ToString, fi.ApprovedByUserId), "?")]);
                }
                else {
                    const approvedAtUtc_2 = matchValue_5[0];
                    const approvedByName_1 = matchValue_5[1];
                    return new FileImportState(6, [approvedAtUtc_2, approvedByName_1]);
                }
            }
            else {
                logei(toText(printf("[FileImportState - OfFileImport] IMPORTING state without ApprovedAtUtc:%A or ApprovedByName: %A"))(fi.ApprovedAtUtc)(fi.ApprovedByName));
                return new FileImportState(7);
            }
        }
        case "STATE_ERROR": {
            return new FileImportState(7);
        }
        default: {
            return new FileImportState(8);
        }
    }
}

export function renderFileImportState(showMsgFn, locale, fi) {
    const fileImportState = FileImportState_OfFileImport_Z76481C2E(fi);
    const patternInput = (fileImportState.tag === 1) ? ["clear", "state__badge--secondary", "Rejected"] : ((fileImportState.tag === 2) ? ["done", "state__badge--success", "Completed"] : ((fileImportState.tag === 3) ? ["hourglass_empty", "state__badge--secondary", "Pending Rejection"] : ((fileImportState.tag === 4) ? ["schedule", "state__badge--secondary", "Parsing"] : ((fileImportState.tag === 5) ? ["hourglass_empty", "state__badge--secondary", "Pending Approval"] : ((fileImportState.tag === 6) ? ["schedule", "state__badge--secondary", "Importing"] : ((fileImportState.tag === 7) ? ["error", "state__badge--danger", "State Error"] : ((fileImportState.tag === 8) ? ["question_mark", "state__badge--danger", "UnknownState"] : ["error", "state__badge--danger", "Error"])))))));
    const stateTranslation = patternInput[2];
    const icon = patternInput[0];
    const badgeCssClass = patternInput[1];
    let pattern_matching_result, name_1, utc_1;
    switch (fileImportState.tag) {
        case 5: {
            pattern_matching_result = 1;
            break;
        }
        case 1: {
            pattern_matching_result = 2;
            name_1 = fileImportState.fields[0][1];
            utc_1 = fileImportState.fields[0][0];
            break;
        }
        case 3: {
            pattern_matching_result = 2;
            name_1 = fileImportState.fields[0][1];
            utc_1 = fileImportState.fields[0][0];
            break;
        }
        case 6: {
            pattern_matching_result = 2;
            name_1 = fileImportState.fields[0][1];
            utc_1 = fileImportState.fields[0][0];
            break;
        }
        case 4: {
            pattern_matching_result = 3;
            break;
        }
        case 0: {
            pattern_matching_result = 4;
            break;
        }
        case 7:
        case 8: {
            pattern_matching_result = 5;
            break;
        }
        default: pattern_matching_result = 0}
    switch (pattern_matching_result) {
        case 0: {
            const utcStr = DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(fileImportState.fields[0][0]));
            const props = [new HTMLAttr(65, stackClasses(ofArray(["state__badge", badgeCssClass, "file-import__state"])))];
            const children = [getWrappedMaterialIcon(icon), toText(printf("%s by %s at %s"))(stateTranslation)(fileImportState.fields[0][1])(utcStr)];
            return react.createElement("span", keyValueList(props, 1), ...children);
        }
        case 1: {
            const props_2 = [new HTMLAttr(65, stackClasses(ofArray(["state__badge", badgeCssClass, "file-import__state"])))];
            const children_2 = [getWrappedMaterialIcon(icon), stateTranslation];
            return react.createElement("span", keyValueList(props_2, 1), ...children_2);
        }
        case 2: {
            const utcStr_1 = DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(utc_1));
            const props_4 = [new HTMLAttr(65, stackClasses(ofArray(["state__badge", badgeCssClass, "file-import__state"])))];
            const children_4 = [getWrappedMaterialIcon(icon), toText(printf("%s by %s at %s"))(stateTranslation)(name_1)(utcStr_1)];
            return react.createElement("span", keyValueList(props_4, 1), ...children_4);
        }
        case 3: {
            const props_6 = [new HTMLAttr(65, stackClasses(ofArray(["state__badge", badgeCssClass, "file-import__state"])))];
            const children_6 = [getWrappedMaterialIcon(icon), stateTranslation];
            return react.createElement("span", keyValueList(props_6, 1), ...children_6);
        }
        case 4: {
            const utcStr_2 = DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(fileImportState.fields[0][0]));
            const props_8 = [new HTMLAttr(65, stackClasses(ofArray(["state__badge", badgeCssClass, "file-import__state", "pointer"]))), new DOMAttr(40, (_arg) => {
                showMsgFn(fileImportState.fields[0][1]);
            })];
            const children_8 = [getWrappedMaterialIcon(icon), toText(printf("Error at %s"))(utcStr_2)];
            return react.createElement("span", keyValueList(props_8, 1), ...children_8);
        }
        case 5: {
            const props_10 = [new HTMLAttr(65, stackClasses(ofArray(["state__badge", badgeCssClass, "file-import__state"])))];
            const children_10 = [getWrappedMaterialIcon(icon), stateTranslation];
            return react.createElement("span", keyValueList(props_10, 1), ...children_10);
        }
    }
}

